export const BlockIcon = () => {
	return (
		<div>
			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
				<rect
					x="15.8"
					y="11.2"
					width="4.6"
					height="4.6"
					rx="1.3"
					transform="rotate(90 15.8 11.2)"
					stroke="#797F84"
					strokeWidth="1.4"
				/>
				<rect
					x="15.8"
					y="4.2"
					width="4.6"
					height="4.6"
					rx="1.3"
					transform="rotate(90 15.8 4.2)"
					stroke="#797F84"
					strokeWidth="1.4"
				/>
				<rect
					x="8.8"
					y="4.2"
					width="4.6"
					height="4.6"
					rx="1.3"
					transform="rotate(90 8.8 4.2)"
					stroke="#797F84"
					strokeWidth="1.4"
				/>
				<rect
					x="8.8"
					y="11.2"
					width="4.6"
					height="4.6"
					rx="1.3"
					transform="rotate(90 8.8 11.2)"
					stroke="#797F84"
					strokeWidth="1.4"
				/>
			</svg>
		</div>
	)
}
